/* Spivi — behaviours for the components. One classic script, no dependencies.
   Markup opts in with data-sp="market" | "chips" | "gate". Spivi.init(root) wires a subtree. */
(function () {
  function marketSwitch(el) {
    var btn = el.querySelector('.sp-market__btn');
    var menu = el.querySelector('.sp-market__menu');
    if (!btn || !menu) return;
    function set(open) { menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    btn.addEventListener('click', function () { set(menu.hidden); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!el.contains(e.target)) set(false); });
  }
  function chips(el) {
    var all = el.querySelectorAll('.sp-chip');
    all.forEach(function (chip) {
      chip.addEventListener('click', function () {
        all.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        el.dispatchEvent(new CustomEvent('sp:filter', { detail: { value: chip.getAttribute('data-value') || chip.textContent.trim() } }));
      });
    });
  }
  function ageGate(el) {
    var KEY = 'spivi-age-ok';
    var ok = false;
    try { ok = window.localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (ok && !el.classList.contains('sp-gate--inline')) { el.hidden = true; return; }
    var yes = el.querySelector('[data-sp-yes]');
    var no = el.querySelector('[data-sp-no]');
    if (yes) yes.addEventListener('click', function () {
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
      if (!el.classList.contains('sp-gate--inline')) el.hidden = true;
      el.dispatchEvent(new CustomEvent('sp:age', { detail: { ok: true } }));
    });
    if (no) no.addEventListener('click', function () {
      el.dispatchEvent(new CustomEvent('sp:age', { detail: { ok: false } }));
      var msg = el.querySelector('[data-sp-denied]');
      if (msg) msg.hidden = false;
    });
  }
  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-sp="market"]').forEach(marketSwitch);
    root.querySelectorAll('[data-sp="chips"]').forEach(chips);
    root.querySelectorAll('[data-sp="gate"]').forEach(ageGate);
  }
  window.Spivi = { init: init, marketSwitch: marketSwitch, chips: chips, ageGate: ageGate };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
/* Theme layer: behaviours the Shopify theme needs on top of the design system.
   data-sp-bgvideo  = a section with a muted background film (hero, spotlight)
   data-sp-film     = a card that opens its film in the shared dialog
   data-sp-event    = a click that is reported through Spivi.track (one event model, no per-section tracking code) */
(function () {
  if (window.__spiviTheme) return;
  window.__spiviTheme = true;
  var S = window.Spivi = window.Spivi || {};
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !!(navigator.connection && navigator.connection.saveData);

  S.track = function (name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('spivi_' + name, data || {});
    } catch (e) {}
  };

  function bgVideo(el) {
    if (el.__sp) return;
    el.__sp = true;
    var v = el.querySelector('video');
    var b = el.querySelector('[data-sp-pause]');
    if (!v) return;
    var small = window.matchMedia('(max-width: 760px)').matches;
    var auto = !calm && !(small && el.getAttribute('data-mobile-video') === 'false');
    var stopped = !auto;
    v.muted = true;
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function label() { if (b) b.textContent = v.paused ? b.getAttribute('data-play') : b.getAttribute('data-pause'); }
    v.addEventListener('playing', function () { v.classList.add('is-on'); });
    v.addEventListener('play', label);
    v.addEventListener('pause', label);
    if (b) {
      b.hidden = false;
      b.addEventListener('click', function () { if (v.paused) { stopped = false; play(); } else { stopped = true; v.pause(); } });
      label();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { if (!stopped) play(); } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(el);
    } else if (auto) { play(); }
  }

  var dlg, slot;
  function dialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    if (!dlg.showModal) { dlg = null; return null; }
    dlg.className = 'sp sp-dialog';
    dlg.setAttribute('aria-label', 'Video');
    dlg.innerHTML = "<button class='sp-btn sp-btn--on-inverse sp-btn--sm sp-dialog__close' type='button' data-sp-close>Luk</button><div data-sp-slot></div>";
    slot = dlg.querySelector('[data-sp-slot]');
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-sp-close]')) dlg.close(); });
    dlg.addEventListener('close', function () { slot.innerHTML = ''; });
    document.body.appendChild(dlg);
    return dlg;
  }

  document.addEventListener('click', function (e) {
    var film = e.target.closest('[data-sp-film]');
    if (film) {
      var t = film.querySelector('template');
      var d = t && dialog();
      if (d) {
        e.preventDefault();
        slot.innerHTML = '';
        slot.appendChild(t.content.cloneNode(true));
        d.showModal();
        var v = slot.querySelector('video');
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        S.track('film_open', { title: film.getAttribute('data-sp-label') || '' });
      }
    }
    var ev = e.target.closest('[data-sp-event]');
    if (ev) S.track(ev.getAttribute('data-sp-event'), { label: ev.getAttribute('data-sp-label') || (ev.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80), href: ev.getAttribute('href') || '' });
    var mono = e.target.closest('[data-sp-monopoly]');
    if (mono) S.track('monopoly_click', { market: mono.getAttribute('data-sp-monopoly'), product: mono.getAttribute('data-sp-product') });
  });

  function init(root) { (root || document).querySelectorAll('[data-sp-bgvideo]').forEach(bgVideo); }
  S.initTheme = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (S.init) S.init(e.target); });
})();
